module.exports = __webpack_public_path__ + "img/btm-blue-curve.644ea403.svg";